
export const AllTimeZones = [
    { id: 'Pacific/Midway', name: 'Midway', utc: '-11:00' },
    { id: 'Pacific/Niue', name: 'Alofi', utc: '-11:00' },
    { id: 'Pacific/Pago_Pago', name: 'Pago Pago, Tāfuna, Ta`ū, Taulaga', utc: '-11:00' },
    { id: 'America/Adak', name: 'Adak', utc: '-10:00' },
    {
        id: 'Pacific/Honolulu',
        name: 'Honolulu, East Honolulu, Pearl City, Hilo, Kailua',
        utc: '-10:00',
    },
    { id: 'Pacific/Rarotonga', name: 'Avarua', utc: '-10:00' },
    { id: 'Pacific/Tahiti', name: 'Faaa, Papeete, Punaauia, Pirae, Mahina', utc: '-10:00' },
    { id: 'Pacific/Marquesas', name: 'Taiohae', utc: '-09:30' },
    {
        id: 'America/Anchorage',
        name: 'Anchorage, Fairbanks, Eagle River, Badger, Knik-Fairview',
        utc: '-09:00',
    },
    { id: 'America/Juneau', name: 'Juneau', utc: '-09:00' },
    { id: 'America/Metlakatla', name: 'Metlakatla', utc: '-09:00' },
    { id: 'America/Nome', name: 'Nome', utc: '-09:00' },
    { id: 'America/Sitka', name: 'Sitka, Ketchikan', utc: '-09:00' },
    { id: 'America/Yakutat', name: 'Yakutat', utc: '-09:00' },
    { id: 'Pacific/Gambier', name: 'Gambier', utc: '-09:00' },
    {
        id: 'America/Los_Angeles',
        name: 'Los Angeles, San Diego, San Jose, San Francisco, Seattle',
        utc: '-08:00',
    },
    { id: 'America/Tijuana', name: 'Tijuana, Mexicali, Ensenada, Rosarito, Tecate', utc: '-08:00' },
    {
        id: 'America/Vancouver',
        name: 'Vancouver, Surrey, Okanagan, Victoria, Burnaby',
        utc: '-08:00',
    },
    { id: 'Pacific/Pitcairn', name: 'Adamstown', utc: '-08:00' },
    { id: 'America/Boise', name: 'Boise, Meridian, Nampa, Idaho Falls, Pocatello', utc: '-07:00' },
    { id: 'America/Cambridge_Bay', name: 'Cambridge Bay', utc: '-07:00' },
    {
        id: 'America/Chihuahua',
        name: 'Chihuahua, Ciudad Delicias, Cuauhtémoc, Parral, Nuevo Casas Grandes',
        utc: '-07:00',
    },
    { id: 'America/Creston', name: 'Creston', utc: '-07:00' },
    { id: 'America/Dawson', name: 'Dawson', utc: '-07:00' },
    { id: 'America/Dawson_Creek', name: 'Fort St. John, Dawson Creek', utc: '-07:00' },
    {
        id: 'America/Denver',
        name: 'Denver, El Paso, Albuquerque, Colorado Springs, Aurora',
        utc: '-07:00',
    },
    {
        id: 'America/Edmonton',
        name: 'Calgary, Edmonton, Fort McMurray, Red Deer, Lethbridge',
        utc: '-07:00',
    },
    { id: 'America/Fort_Nelson', name: 'Fort Nelson', utc: '-07:00' },
    {
        id: 'America/Hermosillo',
        name: 'Hermosillo, Ciudad Obregón, Nogales, San Luis Río Colorado, Navojoa',
        utc: '-07:00',
    },
    { id: 'America/Inuvik', name: 'Inuvik', utc: '-07:00' },
    { id: 'America/Mazatlan', name: 'Culiacán, Mazatlán, Tepic, Los Mochis, La Paz', utc: '-07:00' },
    { id: 'America/Ojinaga', name: 'Ciudad Juárez, Manuel Ojinaga, Ojinaga', utc: '-07:00' },
    { id: 'America/Phoenix', name: 'Phoenix, Tucson, Mesa, Chandler, Gilbert', utc: '-07:00' },
    { id: 'America/Whitehorse', name: 'Whitehorse', utc: '-07:00' },
    { id: 'America/Yellowknife', name: 'Yellowknife', utc: '-07:00' },
    {
        id: 'America/Bahia_Banderas',
        name: 'Mezcales, San Vicente, Bucerías, Valle de Banderas',
        utc: '-06:00',
    },
    {
        id: 'America/Belize',
        name: 'Belize City, San Ignacio, Orange Walk, Belmopan, Dangriga',
        utc: '-06:00',
    },
    { id: 'America/Chicago', name: 'Chicago, Houston, San Antonio, Dallas, Austin', utc: '-06:00' },
    {
        id: 'America/Costa_Rica',
        name: 'San José, Limón, San Francisco, Alajuela, Liberia',
        utc: '-06:00',
    },
    {
        id: 'America/El_Salvador',
        name: 'San Salvador, Soyapango, Santa Ana, San Miguel, Mejicanos',
        utc: '-06:00',
    },
    {
        id: 'America/Guatemala',
        name: 'Guatemala City, Mixco, Villa Nueva, Petapa, San Juan Sacatepéquez',
        utc: '-06:00',
    },
    { id: 'America/Indiana/Knox', name: 'Knox', utc: '-06:00' },
    { id: 'America/Indiana/Tell_City', name: 'Tell City', utc: '-06:00' },
    { id: 'America/Managua', name: 'Managua, León, Masaya, Chinandega, Matagalpa', utc: '-06:00' },
    {
        id: 'America/Matamoros',
        name: 'Reynosa, Heroica Matamoros, Nuevo Laredo, Piedras Negras, Ciudad Acuña',
        utc: '-06:00',
    },
    {
        id: 'America/Menominee',
        name: 'Menominee, Iron Mountain, Kingsford, Ironwood, Iron River',
        utc: '-06:00',
    },
    {
        id: 'America/Merida',
        name: 'Mérida, Campeche, Ciudad del Carmen, Kanasín, Valladolid',
        utc: '-06:00',
    },
    {
        id: 'America/Mexico_City',
        name: 'Mexico City, Iztapalapa, Ecatepec de Morelos, Guadalajara, Puebla',
        utc: '-06:00',
    },
    {
        id: 'America/Monterrey',
        name: 'Monterrey, Saltillo, Guadalupe, Torreón, Victoria de Durango',
        utc: '-06:00',
    },
    { id: 'America/North_Dakota/Beulah', name: 'Beulah', utc: '-06:00' },
    { id: 'America/North_Dakota/Center', name: 'Center', utc: '-06:00' },
    { id: 'America/North_Dakota/New_Salem', name: 'Mandan', utc: '-06:00' },
    { id: 'America/Rainy_River', name: 'Rainy River', utc: '-06:00' },
    { id: 'America/Rankin_Inlet', name: 'Rankin Inlet', utc: '-06:00' },
    {
        id: 'America/Regina',
        name: 'Saskatoon, Regina, Prince Albert, Moose Jaw, North Battleford',
        utc: '-06:00',
    },
    { id: 'America/Resolute', name: 'Resolute', utc: '-06:00' },
    { id: 'America/Swift_Current', name: 'Swift Current', utc: '-06:00' },
    {
        id: 'America/Tegucigalpa',
        name: 'Tegucigalpa, San Pedro Sula, Choloma, La Ceiba, El Progreso',
        utc: '-06:00',
    },
    {
        id: 'America/Winnipeg',
        name: 'Winnipeg, Brandon, Kenora, Portage la Prairie, Thompson',
        utc: '-06:00',
    },
    { id: 'Pacific/Easter', name: 'Easter', utc: '-06:00' },
    { id: 'Pacific/Galapagos', name: 'Puerto Ayora, Puerto Baquerizo Moreno', utc: '-06:00' },
    { id: 'America/Atikokan', name: 'Atikokan', utc: '-05:00' },
    { id: 'America/Bogota', name: 'Bogotá, Cali, Medellín, Barranquilla, Cartagena', utc: '-05:00' },
    {
        id: 'America/Cancun',
        name: 'Cancún, Chetumal, Playa del Carmen, Cozumel, Felipe Carrillo Puerto',
        utc: '-05:00',
    },
    {
        id: 'America/Cayman',
        name: 'George Town, West Bay, Bodden Town, East End, North Side',
        utc: '-05:00',
    },
    {
        id: 'America/Detroit',
        name: 'Detroit, Grand Rapids, Warren, Sterling Heights, Ann Arbor',
        utc: '-05:00',
    },
    { id: 'America/Eirunepe', name: 'Eirunepé, Benjamin Constant, Envira', utc: '-05:00' },
    { id: 'America/Grand_Turk', name: 'Cockburn Town', utc: '-05:00' },
    {
        id: 'America/Guayaquil',
        name: 'Guayaquil, Quito, Cuenca, Santo Domingo de los Colorados, Machala',
        utc: '-05:00',
    },
    {
        id: 'America/Havana',
        name: 'Havana, Santiago de Cuba, Camagüey, Holguín, Guantánamo',
        utc: '-05:00',
    },
    {
        id: 'America/Indiana/Indianapolis',
        name: 'Indianapolis, Fort Wayne, South Bend, Carmel, Bloomington',
        utc: '-05:00',
    },
    { id: 'America/Indiana/Marengo', name: 'Marengo', utc: '-05:00' },
    { id: 'America/Indiana/Petersburg', name: 'Petersburg', utc: '-05:00' },
    { id: 'America/Indiana/Vevay', name: 'Vevay', utc: '-05:00' },
    {
        id: 'America/Indiana/Vincennes',
        name: 'Vincennes, Jasper, Washington, Huntingburg',
        utc: '-05:00',
    },
    { id: 'America/Indiana/Winamac', name: 'Winamac', utc: '-05:00' },
    { id: 'America/Iqaluit', name: 'Iqaluit', utc: '-05:00' },
    {
        id: 'America/Jamaica',
        name: 'Kingston, New Kingston, Spanish Town, Portmore, Montego Bay',
        utc: '-05:00',
    },
    {
        id: 'America/Kentucky/Louisville',
        name: 'Louisville, Jeffersonville, New Albany, Jeffersontown, Pleasure Ridge Park',
        utc: '-05:00',
    },
    { id: 'America/Kentucky/Monticello', name: 'Monticello', utc: '-05:00' },
    { id: 'America/Lima', name: 'Lima, Arequipa, Callao, Trujillo, Chiclayo', utc: '-05:00' },
    {
        id: 'America/Nassau',
        name: "Nassau, Lucaya, Freeport, West End, Cooper's Town",
        utc: '-05:00',
    },
    {
        id: 'America/New_York',
        name: 'New York City, Brooklyn, Queens, Philadelphia, Manhattan',
        utc: '-05:00',
    },
    { id: 'America/Nipigon', name: 'Nipigon', utc: '-05:00' },
    {
        id: 'America/Panama',
        name: 'Panamá, San Miguelito, Juan Díaz, David, Arraiján',
        utc: '-05:00',
    },
    { id: 'America/Pangnirtung', name: 'Pangnirtung', utc: '-05:00' },
    {
        id: 'America/Port-au-Prince',
        name: 'Port-au-Prince, Carrefour, Delmas 73, Pétionville, Port-de-Paix',
        utc: '-05:00',
    },
    {
        id: 'America/Rio_Branco',
        name: 'Rio Branco, Cruzeiro do Sul, Sena Madureira, Tarauacá, Feijó',
        utc: '-05:00',
    },
    { id: 'America/Thunder_Bay', name: 'Thunder Bay', utc: '-05:00' },
    { id: 'America/Toronto', name: 'Toronto, Montréal, Ottawa, Mississauga, Québec', utc: '-05:00' },
    {
        id: 'America/AnguillaSandy Hill',
        name: 'The Valley, Blowing Point Village, Sandy Ground Village, The Quarter, Sandy Hill',
        utc: '-04:00',
    },
    {
        id: 'America/Antigua',
        name: "Saint John's, Piggotts, Bolands, Codrington, Parham",
        utc: '-04:00',
    },
    {
        id: 'America/Aruba',
        name: 'Oranjestad, Tanki Leendert, San Nicolas, Santa Cruz, Paradera',
        utc: '-04:00',
    },
    {
        id: 'America/Asuncion',
        name: 'Asunción, Ciudad del Este, San Lorenzo, Capiatá, Lambaré',
        utc: '-04:00',
    },
    {
        id: 'America/Barbados',
        name: 'Bridgetown, Speightstown, Oistins, Bathsheba, Holetown',
        utc: '-04:00',
    },
    { id: 'America/Blanc-Sablon', name: 'Lévis', utc: '-04:00' },
    { id: 'America/Boa_Vista', name: 'Boa Vista', utc: '-04:00' },
    {
        id: 'America/Campo_Grande',
        name: 'Campo Grande, Dourados, Corumbá, Três Lagoas, Ponta Porã',
        utc: '-04:00',
    },
    {
        id: 'America/Caracas',
        name: 'Caracas, Maracaibo, Maracay, Valencia, Barquisimeto',
        utc: '-04:00',
    },
    {
        id: 'America/Cuiaba',
        name: 'Cuiabá, Várzea Grande, Rondonópolis, Sinop, Barra do Garças',
        utc: '-04:00',
    },
    { id: 'America/Curacao', name: 'Willemstad, Sint Michiel Liber', utc: '-04:00' },
    {
        id: 'America/Dominica',
        name: 'Roseau, Portsmouth, Berekua, Saint Joseph, Wesley',
        utc: '-04:00',
    },
    { id: 'America/Glace_Bay', name: 'Sydney, Glace Bay, Sydney Mines', utc: '-04:00' },
    { id: 'America/Goose_Bay', name: 'Labrador City, Happy Valley-Goose Bay', utc: '-04:00' },
    {
        id: 'America/Grenada',
        name: "Saint George's, Gouyave, Grenville, Victoria, Saint David's",
        utc: '-04:00',
    },
    {
        id: 'America/Guadeloupe',
        name: 'Les Abymes, Baie-Mahault, Le Gosier, Petit-Bourg, Sainte-Anne',
        utc: '-04:00',
    },
    {
        id: 'America/Guyana',
        name: 'Georgetown, Linden, New Amsterdam, Anna Regina, Bartica',
        utc: '-04:00',
    },
    {
        id: 'America/Halifax',
        name: 'Halifax, Dartmouth, Charlottetown, Lower Sackville, Truro',
        utc: '-04:00',
    },
    { id: 'America/Kralendijk', name: 'Kralendijk, Oranjestad, The Bottom', utc: '-04:00' },
    {
        id: 'America/La_Paz',
        name: 'Santa Cruz de la Sierra, Cochabamba, La Paz, Sucre, Oruro',
        utc: '-04:00',
    },
    {
        id: 'America/Lower_Princes',
        name: "Cul de Sac, Lower Prince's Quarter, Koolbaai, Philipsburg",
        utc: '-04:00',
    },
    {
        id: 'America/Manaus',
        name: 'Manaus, Itacoatiara, Parintins, Manacapuru, Coari',
        utc: '-04:00',
    },
    { id: 'America/Marigot', name: 'Marigot', utc: '-04:00' },
    {
        id: 'America/Martinique',
        name: 'Fort-de-France, Le Lamentin, Le Robert, Sainte-Marie, Le François',
        utc: '-04:00',
    },
    {
        id: 'America/Moncton',
        name: 'Moncton, Saint John, Fredericton, Dieppe, Miramichi',
        utc: '-04:00',
    },
    { id: 'America/Montserrat', name: 'Brades, Saint Peters, Plymouth', utc: '-04:00' },
    {
        id: 'America/Porto_Velho',
        name: 'Porto Velho, Ji Paraná, Vilhena, Ariquemes, Cacoal',
        utc: '-04:00',
    },
    {
        id: 'America/Port_of_Spain',
        name: 'Chaguanas, Mon Repos, San Fernando, Port of Spain, Rio Claro',
        utc: '-04:00',
    },
    { id: 'America/Puerto_Rico', name: 'San Juan, Bayamón, Carolina, Ponce, Caguas', utc: '-04:00' },
    {
        id: 'America/Santiago',
        name: 'Santiago, Puente Alto, Antofagasta, Viña del Mar, Valparaíso',
        utc: '-04:00',
    },
    {
        id: 'America/Santo_Domingo',
        name: 'Santo Domingo, Santiago de los Caballeros, Santo Domingo Oeste, Santo Domingo Este, San Pedro de Macorís',
        utc: '-04:00',
    },
    { id: 'America/St_Barthelemy', name: 'Gustavia', utc: '-04:00' },
    {
        id: 'America/St_Kitts',
        name: "Basseterre, Fig Tree, Market Shop, Saint Paul's, Middle Island",
        utc: '-04:00',
    },
    { id: 'America/St_Lucia', name: 'Castries, Bisee, Vieux Fort, Micoud, Soufrière', utc: '-04:00' },
    { id: 'America/St_Thomas', name: 'Saint Croix, Charlotte Amalie, Cruz Bay', utc: '-04:00' },
    {
        id: 'America/St_Vincent',
        name: 'Kingstown, Kingstown Park, Georgetown, Barrouallie, Port Elizabeth',
        utc: '-04:00',
    },
    { id: 'America/Thule', name: 'Thule', utc: '-04:00' },
    { id: 'America/Tortola', name: 'Road Town', utc: '-04:00' },
    { id: 'Atlantic/Bermuda', name: 'Hamilton', utc: '-04:00' },
    {
        id: 'America/St_Johns',
        name: "St. John's, Mount Pearl, Corner Brook, Conception Bay South, Bay Roberts",
        utc: '-03:30',
    },
    {
        id: 'America/Araguaina',
        name: 'Palmas, Araguaína, Gurupi, Miracema do Tocantins, Porto Franco',
        utc: '-03:00',
    },
    {
        id: 'America/Argentina/Buenos_Aires',
        name: 'Buenos Aires, La Plata, Mar del Plata, Morón, Bahía Blanca',
        utc: '-03:00',
    },
    {
        id: 'America/Argentina/Catamarca',
        name: 'San Fernando del Valle de Catamarca, Trelew, Puerto Madryn, Esquel, Rawson',
        utc: '-03:00',
    },
    {
        id: 'America/Argentina/Cordoba',
        name: 'Córdoba, Rosario, Santa Fe, Resistencia, Santiago del Estero',
        utc: '-03:00',
    },
    {
        id: 'America/Argentina/Jujuy',
        name: 'San Salvador de Jujuy, San Pedro de Jujuy, Libertador General San Martín, Palpalá, La Quiaca',
        utc: '-03:00',
    },
    {
        id: 'America/Argentina/La_Rioja',
        name: 'La Rioja, Chilecito, Arauco, Chamical',
        utc: '-03:00',
    },
    { id: 'America/Argentina/Mendoza', name: 'Mendoza, San Rafael, San Martín', utc: '-03:00' },
    {
        id: 'America/Argentina/Rio_Gallegos',
        name: 'Comodoro Rivadavia, Río Gallegos, Caleta Olivia, Pico Truncado, Puerto Deseado',
        utc: '-03:00',
    },
    {
        id: 'America/Argentina/Salta',
        name: 'Salta, Neuquén, Santa Rosa, San Carlos de Bariloche, Cipolletti',
        utc: '-03:00',
    },
    {
        id: 'America/Argentina/San_Juan',
        name: 'San Juan, Chimbas, Santa Lucía, Pocito, Caucete',
        utc: '-03:00',
    },
    {
        id: 'America/Argentina/San_Luis',
        name: 'San Luis, Villa Mercedes, La Punta, Merlo, Justo Daract',
        utc: '-03:00',
    },
    {
        id: 'America/Argentina/Tucuman',
        name: 'San Miguel de Tucumán, Yerba Buena, Tafí Viejo, Alderetes, Aguilares',
        utc: '-03:00',
    },
    { id: 'America/Argentina/Ushuaia', name: 'Ushuaia, Río Grande', utc: '-03:00' },
    {
        id: 'America/Bahia',
        name: 'Salvador, Feira de Santana, Vitória da Conquista, Itabuna, Camaçari',
        utc: '-03:00',
    },
    { id: 'America/Belem', name: 'Belém, Ananindeua, Macapá, Parauapebas, Marabá', utc: '-03:00' },
    {
        id: 'America/Cayenne',
        name: 'Cayenne, Matoury, Saint-Laurent-du-Maroni, Kourou, Rémire-Montjoly',
        utc: '-03:00',
    },
    {
        id: 'America/Fortaleza',
        name: 'Fortaleza, São Luís, Natal, Teresina, João Pessoa',
        utc: '-03:00',
    },
    { id: 'America/Godthab', name: 'Nuuk, Sisimiut, Ilulissat, Qaqortoq, Aasiaat', utc: '-03:00' },
    {
        id: 'America/Maceio',
        name: 'Maceió, Aracaju, Arapiraca, Nossa Senhora do Socorro, São Cristóvão',
        utc: '-03:00',
    },
    { id: 'America/Miquelon', name: 'Saint-Pierre, Miquelon', utc: '-03:00' },
    {
        id: 'America/Montevideo',
        name: 'Montevideo, Salto, Paysandú, Las Piedras, Rivera',
        utc: '-03:00',
    },
    {
        id: 'America/Paramaribo',
        name: 'Paramaribo, Lelydorp, Brokopondo, Nieuw Nickerie, Moengo',
        utc: '-03:00',
    },
    { id: 'America/Punta_Arenas', name: 'Punta Arenas, Puerto Natales', utc: '-03:00' },
    {
        id: 'America/Recife',
        name: 'Recife, Jaboatão, Jaboatão dos Guararapes, Olinda, Paulista',
        utc: '-03:00',
    },
    {
        id: 'America/Santarem',
        name: 'Santarém, Altamira, Itaituba, Oriximiná, Alenquer',
        utc: '-03:00',
    },
    {
        id: 'America/Sao_Paulo',
        name: 'São Paulo, Rio de Janeiro, Belo Horizonte, Brasília, Curitiba',
        utc: '-03:00',
    },
    { id: 'Antarctica/Palmer', name: 'Palmer', utc: '-03:00' },
    { id: 'Antarctica/Rothera', name: 'Rothera', utc: '-03:00' },
    { id: 'Atlantic/Stanley', name: 'Stanley', utc: '-03:00' },
    { id: 'America/Noronha', name: 'Itamaracá', utc: '-02:00' },
    { id: 'Atlantic/South_Georgia', name: 'Grytviken', utc: '-02:00' },
    { id: 'America/Scoresbysund', name: 'Scoresbysund', utc: '-01:00' },
    {
        id: 'Atlantic/Azores',
        name: 'Ponta Delgada, Lagoa, Angra do Heroísmo, Rosto de Cão, Rabo de Peixe',
        utc: '-01:00',
    },
    {
        id: 'Atlantic/Cape_Verde',
        name: 'Praia, Mindelo, Santa Maria, Cova Figueira, Santa Cruz',
        utc: '-01:00',
    },
    { id: 'Africa/Abidjan', name: 'Abidjan, Abobo, Bouaké, Daloa, San-Pédro', utc: '+00:00' },
    { id: 'Africa/Accra', name: 'Accra, Kumasi, Tamale, Takoradi, Atsiaman', utc: '+00:00' },
    { id: 'Africa/Bamako', name: 'Bamako, Sikasso, Mopti, Koutiala, Ségou', utc: '+00:00' },
    { id: 'Africa/Banjul', name: 'Serekunda, Brikama, Bakau, Banjul, Farafenni', utc: '+00:00' },
    { id: 'Africa/Bissau', name: 'Bissau, Bafatá, Gabú, Bissorã, Bolama', utc: '+00:00' },
    { id: 'Africa/Casablanca', name: 'Casablanca, Rabat, Fès, Sale, Marrakesh', utc: '+00:00' },
    { id: 'Africa/Conakry', name: 'Camayenne, Conakry, Nzérékoré, Kindia, Kankan', utc: '+00:00' },
    { id: 'Africa/Dakar', name: 'Dakar, Pikine, Touba, Thiès, Thiès Nones', utc: '+00:00' },
    { id: 'Africa/El_Aaiun', name: 'Laayoune, Dakhla, Laayoune Plage', utc: '+00:00' },
    { id: 'Africa/Freetown', name: 'Freetown, Bo, Kenema, Koidu, Makeni', utc: '+00:00' },
    { id: 'Africa/Lome', name: 'Lomé, Sokodé, Kara, Atakpamé, Kpalimé', utc: '+00:00' },
    { id: 'Africa/Monrovia', name: 'Monrovia, Gbarnga, Kakata, Bensonville, Harper', utc: '+00:00' },
    { id: 'Africa/Nouakchott', name: 'Nouakchott, Nouadhibou, Néma, Kaédi, Rosso', utc: '+00:00' },
    {
        id: 'Africa/Ouagadougou',
        name: 'Ouagadougou, Bobo-Dioulasso, Koudougou, Ouahigouya, Banfora',
        utc: '+00:00',
    },
    { id: 'Africa/Sao_Tome', name: 'São Tomé, Santo António', utc: '+00:00' },
    { id: 'America/Danmarkshavn', name: 'Danmarkshavn', utc: '+00:00' },
    { id: 'Antarctica/Troll', name: 'Troll', utc: '+00:00' },
    {
        id: 'Atlantic/Canary',
        name: 'Las Palmas de Gran Canaria, Santa Cruz de Tenerife, La Laguna, Telde, Arona',
        utc: '+00:00',
    },
    {
        id: 'Atlantic/Faroe',
        name: 'Tórshavn, Klaksvík, Fuglafjørður, Tvøroyri, Miðvágur',
        utc: '+00:00',
    },
    {
        id: 'Atlantic/Madeira',
        name: 'Funchal, Câmara de Lobos, São Martinho, Caniço, Machico',
        utc: '+00:00',
    },
    {
        id: 'Atlantic/Reykjavik',
        name: 'Reykjavík, Kópavogur, Hafnarfjörður, Akureyri, Garðabær',
        utc: '+00:00',
    },
    {
        id: 'Atlantic/St_Helena',
        name: 'Jamestown, Georgetown, Edinburgh of the Seven Seas',
        utc: '+00:00',
    },
    { id: 'Europe/Dublin', name: 'Dublin, Cork, Luimneach, Gaillimh, Tallaght', utc: '+00:00' },
    {
        id: 'Europe/Guernsey',
        name: 'Saint Peter Port, St Martin, Saint Sampson, St Anne, Saint Saviour',
        utc: '+00:00',
    },
    { id: 'Europe/Isle_of_Man', name: 'Douglas, Ramsey, Peel, Port Erin, Castletown', utc: '+00:00' },
    { id: 'Europe/Jersey', name: 'Saint Helier, Le Hocq', utc: '+00:00' },
    { id: 'Europe/Lisbon', name: 'Lisbon, Porto, Amadora, Braga, Setúbal', utc: '+00:00' },
    { id: 'Europe/London', name: 'London, Birmingham, Liverpool, Sheffield, Bristol', utc: '+00:00' },
    { id: 'Africa/Algiers', name: 'Algiers, Boumerdas, Oran, Tébessa, Constantine', utc: '+01:00' },
    { id: 'Africa/Bangui', name: 'Bangui, Bimbo, Mbaïki, Berbérati, Kaga Bandoro', utc: '+01:00' },
    {
        id: 'Africa/Brazzaville',
        name: 'Brazzaville, Pointe-Noire, Dolisie, Kayes, Owando',
        utc: '+01:00',
    },
    { id: 'Africa/Ceuta', name: 'Ceuta, Melilla', utc: '+01:00' },
    { id: 'Africa/Douala', name: 'Douala, Yaoundé, Garoua, Kousséri, Bamenda', utc: '+01:00' },
    { id: 'Africa/Kinshasa', name: 'Kinshasa, Masina, Kikwit, Mbandaka, Matadi', utc: '+01:00' },
    { id: 'Africa/Lagos', name: 'Lagos, Kano, Ibadan, Kaduna, Port Harcourt', utc: '+01:00' },
    {
        id: 'Africa/Libreville',
        name: 'Libreville, Port-Gentil, Franceville, Oyem, Moanda',
        utc: '+01:00',
    },
    { id: 'Africa/Luanda', name: "Luanda, N'dalatando, Huambo, Lobito, Benguela", utc: '+01:00' },
    { id: 'Africa/Malabo', name: 'Bata, Malabo, Ebebiyin, Aconibe, Añisoc', utc: '+01:00' },
    { id: 'Africa/Ndjamena', name: "N'Djamena, Moundou, Sarh, Abéché, Kelo", utc: '+01:00' },
    { id: 'Africa/Niamey', name: 'Niamey, Zinder, Maradi, Agadez, Alaghsas', utc: '+01:00' },
    {
        id: 'Africa/Porto-Novo',
        name: 'Cotonou, Abomey-Calavi, Djougou, Porto-Novo, Parakou',
        utc: '+01:00',
    },
    { id: 'Africa/Tunis', name: 'Tunis, Sfax, Sousse, Kairouan, Bizerte', utc: '+01:00' },
    {
        id: 'Africa/Windhoek',
        name: 'Windhoek, Rundu, Walvis Bay, Oshakati, Swakopmund',
        utc: '+01:00',
    },
    { id: 'Arctic/Longyearbyen', name: 'Longyearbyen, Olonkinbyen', utc: '+01:00' },
    {
        id: 'Europe/Amsterdam',
        name: 'Amsterdam, Rotterdam, The Hague, Utrecht, Eindhoven',
        utc: '+01:00',
    },
    {
        id: 'Europe/Andorra',
        name: 'Andorra la Vella, les Escaldes, Encamp, Sant Julià de Lòria, la Massana',
        utc: '+01:00',
    },
    { id: 'Europe/Belgrade', name: 'Belgrade, Pristina, Niš, Novi Sad, Prizren', utc: '+01:00' },
    { id: 'Europe/Berlin', name: 'Berlin, Hamburg, Munich, Köln, Frankfurt am Main', utc: '+01:00' },
    { id: 'Europe/Bratislava', name: 'Bratislava, Košice, Prešov, Nitra, Žilina', utc: '+01:00' },
    { id: 'Europe/Brussels', name: 'Brussels, Antwerpen, Gent, Charleroi, Liège', utc: '+01:00' },
    { id: 'Europe/Budapest', name: 'Budapest, Debrecen, Miskolc, Szeged, Pécs', utc: '+01:00' },
    {
        id: 'Europe/Copenhagen',
        name: 'Copenhagen, Århus, Odense, Aalborg, Frederiksberg',
        utc: '+01:00',
    },
    { id: 'Europe/Gibraltar', name: 'Gibraltar', utc: '+01:00' },
    { id: 'Europe/Ljubljana', name: 'Ljubljana, Maribor, Celje, Kranj, Velenje', utc: '+01:00' },
    {
        id: 'Europe/Luxembourg',
        name: 'Luxembourg, Esch-sur-Alzette, Dudelange, Schifflange, Bettembourg',
        utc: '+01:00',
    },
    { id: 'Europe/Madrid', name: 'Madrid, Barcelona, Valencia, Sevilla, Zaragoza', utc: '+01:00' },
    {
        id: 'Europe/Malta',
        name: 'Birkirkara, Qormi, Mosta, Żabbar, San Pawl il-Baħar',
        utc: '+01:00',
    },
    { id: 'Europe/Monaco', name: 'Monaco, Monte-Carlo, La Condamine', utc: '+01:00' },
    { id: 'Europe/Oslo', name: 'Oslo, Bergen, Trondheim, Stavanger, Drammen', utc: '+01:00' },
    { id: 'Europe/Paris', name: 'Paris, Marseille, Lyon, Toulouse, Nice', utc: '+01:00' },
    {
        id: 'Europe/Podgorica',
        name: 'Podgorica, Nikšić, Herceg Novi, Pljevlja, Budva',
        utc: '+01:00',
    },
    { id: 'Europe/Prague', name: 'Prague, Brno, Ostrava, Pilsen, Olomouc', utc: '+01:00' },
    { id: 'Europe/Rome', name: 'Rome, Milan, Naples, Turin, Palermo', utc: '+01:00' },
    {
        id: 'Europe/San_Marino',
        name: 'Serravalle, Borgo Maggiore, San Marino, Domagnano, Fiorentino',
        utc: '+01:00',
    },
    { id: 'Europe/Sarajevo', name: 'Sarajevo, Banja Luka, Zenica, Tuzla, Mostar', utc: '+01:00' },
    { id: 'Europe/Skopje', name: 'Skopje, Bitola, Kumanovo, Prilep, Tetovo', utc: '+01:00' },
    {
        id: 'Europe/Stockholm',
        name: 'Stockholm, Göteborg, Malmö, Uppsala, Sollentuna',
        utc: '+01:00',
    },
    { id: 'Europe/Tirane', name: 'Tirana, Durrës, Elbasan, Vlorë, Shkodër', utc: '+01:00' },
    { id: 'Europe/Vaduz', name: 'Schaan, Vaduz, Triesen, Balzers, Eschen', utc: '+01:00' },
    { id: 'Europe/Vatican', name: 'Vatican City', utc: '+01:00' },
    { id: 'Europe/Vienna', name: 'Vienna, Graz, Linz, Favoriten, Donaustadt', utc: '+01:00' },
    { id: 'Europe/Warsaw', name: 'Warsaw, Łódź, Kraków, Wrocław, Poznań', utc: '+01:00' },
    { id: 'Europe/Zagreb', name: 'Zagreb, Split, Rijeka, Osijek, Zadar', utc: '+01:00' },
    { id: 'Europe/Zurich', name: 'Zürich, Genève, Basel, Lausanne, Bern', utc: '+01:00' },
    { id: 'Africa/Blantyre', name: 'Lilongwe, Blantyre, Mzuzu, Zomba, Kasungu', utc: '+02:00' },
    { id: 'Africa/Bujumbura', name: 'Bujumbura, Muyinga, Gitega, Ruyigi, Ngozi', utc: '+02:00' },
    { id: 'Africa/Cairo', name: 'Cairo, Alexandria, Giza, Port Said, Suez', utc: '+02:00' },
    {
        id: 'Africa/Gaborone',
        name: 'Gaborone, Francistown, Molepolole, Selebi-Phikwe, Maun',
        utc: '+02:00',
    },
    { id: 'Africa/Harare', name: 'Harare, Bulawayo, Chitungwiza, Mutare, Gweru', utc: '+02:00' },
    {
        id: 'Africa/Johannesburg',
        name: 'Cape Town, Durban, Johannesburg, Soweto, Pretoria',
        utc: '+02:00',
    },
    { id: 'Africa/Juba', name: 'Juba, Winejok, Malakal, Wau, Kuacjok', utc: '+02:00' },
    { id: 'Africa/Khartoum', name: 'Khartoum, Omdurman, Nyala, Port Sudan, Kassala', utc: '+02:00' },
    { id: 'Africa/Kigali', name: 'Kigali, Butare, Gitarama, Musanze, Gisenyi', utc: '+02:00' },
    {
        id: 'Africa/Lubumbashi',
        name: 'Lubumbashi, Mbuji-Mayi, Kisangani, Kananga, Likasi',
        utc: '+02:00',
    },
    { id: 'Africa/Lusaka', name: 'Lusaka, Kitwe, Ndola, Kabwe, Chingola', utc: '+02:00' },
    { id: 'Africa/Maputo', name: 'Maputo, Matola, Beira, Nampula, Chimoio', utc: '+02:00' },
    { id: 'Africa/Maseru', name: "Maseru, Mafeteng, Leribe, Maputsoe, Mohale's Hoek", utc: '+02:00' },
    { id: 'Africa/Mbabane', name: 'Manzini, Mbabane, Big Bend, Malkerns, Nhlangano', utc: '+02:00' },
    { id: 'Africa/Tripoli', name: 'Tripoli, Benghazi, Mişrātah, Tarhuna, Al Khums', utc: '+02:00' },
    { id: 'Asia/Amman', name: 'Amman, Zarqa, Irbid, Russeifa, Wādī as Sīr', utc: '+02:00' },
    { id: 'Asia/Beirut', name: "Beirut, Ra's Bayrūt, Tripoli, Sidon, Tyre", utc: '+02:00' },
    { id: 'Asia/Damascus', name: 'Aleppo, Damascus, Homs, Ḩamāh, Latakia', utc: '+02:00' },
    {
        id: 'Asia/Famagusta',
        name: 'Famagusta, Kyrenia, Protaras, Paralímni, Lápithos',
        utc: '+02:00',
    },
    { id: 'Asia/Gaza', name: 'Gaza, Khān Yūnis, Jabālyā, Rafaḩ, Dayr al Balaḩ', utc: '+02:00' },
    { id: 'Asia/Hebron', name: 'East Jerusalem, Hebron, Nablus, Battir, Ţūlkarm', utc: '+02:00' },
    {
        id: 'Asia/Jerusalem',
        name: 'Jerusalem, Tel Aviv, West Jerusalem, Haifa, Ashdod',
        utc: '+02:00',
    },
    { id: 'Asia/Nicosia', name: 'Nicosia, Limassol, Larnaca, Stróvolos, Paphos', utc: '+02:00' },
    { id: 'Europe/Athens', name: 'Athens, Thessaloníki, Pátra, Piraeus, Lárisa', utc: '+02:00' },
    { id: 'Europe/Bucharest', name: 'Bucharest, Sector 3, Sector 6, Sector 2, Iaşi', utc: '+02:00' },
    { id: 'Europe/Chisinau', name: 'Chisinau, Tiraspol, Bălţi, Bender, Rîbniţa', utc: '+02:00' },
    { id: 'Europe/Helsinki', name: 'Helsinki, Espoo, Tampere, Vantaa, Turku', utc: '+02:00' },
    {
        id: 'Europe/Kaliningrad',
        name: 'Kaliningrad, Chernyakhovsk, Sovetsk, Baltiysk, Gusev',
        utc: '+02:00',
    },
    { id: 'Europe/Kiev', name: 'Kyiv, Kharkiv, Donetsk, Odessa, Dnipro', utc: '+02:00' },
    { id: 'Europe/Mariehamn', name: 'Mariehamn', utc: '+02:00' },
    { id: 'Europe/Riga', name: 'Riga, Daugavpils, Liepāja, Jelgava, Jūrmala', utc: '+02:00' },
    { id: 'Europe/Sofia', name: 'Sofia, Plovdiv, Varna, Burgas, Ruse', utc: '+02:00' },
    { id: 'Europe/Tallinn', name: 'Tallinn, Tartu, Narva, Kohtla-Järve, Pärnu', utc: '+02:00' },
    { id: 'Europe/Uzhgorod', name: 'Uzhgorod, Mukachevo, Khust, Berehove, Tyachiv', utc: '+02:00' },
    { id: 'Europe/Vilnius', name: 'Vilnius, Kaunas, Klaipėda, Šiauliai, Panevėžys', utc: '+02:00' },
    {
        id: 'Europe/Zaporozhye',
        name: 'Luhansk, Sevastopol, Sievierodonetsk, Alchevsk, Lysychansk',
        utc: '+02:00',
    },
    {
        id: 'Africa/Addis_Ababa',
        name: "Addis Ababa, Dire Dawa, Mek'ele, Nazrēt, Bahir Dar",
        utc: '+03:00',
    },
    { id: 'Africa/Asmara', name: 'Asmara, Keren, Massawa, Assab, Mendefera', utc: '+03:00' },
    {
        id: 'Africa/Dar_es_Salaam',
        name: 'Dar es Salaam, Mwanza, Zanzibar, Arusha, Mbeya',
        utc: '+03:00',
    },
    { id: 'Africa/Djibouti', name: "Djibouti, 'Ali Sabieh, Tadjourah, Obock, Dikhil", utc: '+03:00' },
    { id: 'Africa/Kampala', name: 'Kampala, Gulu, Lira, Mbarara, Jinja', utc: '+03:00' },
    { id: 'Africa/Mogadishu', name: 'Mogadishu, Hargeysa, Berbera, Kismayo, Marka', utc: '+03:00' },
    { id: 'Africa/Nairobi', name: 'Nairobi, Mombasa, Nakuru, Eldoret, Kisumu', utc: '+03:00' },
    { id: 'Antarctica/Syowa', name: 'Syowa', utc: '+03:00' },
    { id: 'Asia/Aden', name: 'Sanaa, Al Ḩudaydah, Taiz, Aden, Mukalla', utc: '+03:00' },
    {
        id: 'Asia/Baghdad',
        name: 'Baghdad, Basrah, Al Mawşil al Jadīdah, Al Başrah al Qadīmah, Mosul',
        utc: '+03:00',
    },
    {
        id: 'Asia/Bahrain',
        name: "Manama, Al Muharraq, Ar Rifā', Dār Kulayb, Madīnat Ḩamad",
        utc: '+03:00',
    },
    {
        id: 'Asia/Kuwait',
        name: 'Al Aḩmadī, Ḩawallī, As Sālimīyah, Şabāḩ as Sālim, Al Farwānīyah',
        utc: '+03:00',
    },
    {
        id: 'Asia/Qatar',
        name: 'Doha, Ar Rayyān, Umm Şalāl Muḩammad, Al Wakrah, Al Khawr',
        utc: '+03:00',
    },
    { id: 'Asia/Riyadh', name: 'Riyadh, Jeddah, Mecca, Medina, Sulţānah', utc: '+03:00' },
    { id: 'Europe/Istanbul', name: 'Istanbul, Ankara, İzmir, Bursa, Adana', utc: '+03:00' },
    {
        id: 'Europe/Kirov',
        name: "Kirov, Kirovo-Chepetsk, Vyatskiye Polyany, Slobodskoy, Kotel'nich",
        utc: '+03:00',
    },
    { id: 'Europe/Minsk', name: "Minsk, Homyel', Mahilyow, Vitebsk, Hrodna", utc: '+03:00' },
    {
        id: 'Europe/Moscow',
        name: 'Moscow, Saint Petersburg, Nizhniy Novgorod, Kazan, Rostov-na-Donu',
        utc: '+03:00',
    },
    {
        id: 'Europe/Simferopol',
        name: 'Simferopol, Kerch, Yevpatoriya, Yalta, Feodosiya',
        utc: '+03:00',
    },
    {
        id: 'Europe/Volgograd',
        name: 'Volgograd, Volzhskiy, Kamyshin, Mikhaylovka, Uryupinsk',
        utc: '+03:00',
    },
    {
        id: 'Indian/Antananarivo',
        name: 'Antananarivo, Toamasina, Antsirabe, Fianarantsoa, Mahajanga',
        utc: '+03:00',
    },
    { id: 'Indian/Comoro', name: 'Moroni, Moutsamoudou, Fomboni, Domoni, Tsimbeo', utc: '+03:00' },
    { id: 'Indian/Mayotte', name: 'Mamoudzou, Koungou, Dzaoudzi, Dembeni, Sada', utc: '+03:00' },
    { id: 'Asia/Tehran', name: 'Tehran, Mashhad, Isfahan, Karaj, Tabriz', utc: '+03:30' },
    { id: 'Asia/Baku', name: 'Baku, Ganja, Sumqayıt, Lankaran, Yevlakh', utc: '+04:00' },
    {
        id: 'Asia/Dubai',
        name: 'Dubai, Sharjah, Abu Dhabi, Ajman City, Ras Al Khaimah City',
        utc: '+04:00',
    },
    { id: 'Asia/Muscat', name: 'Muscat, Seeb, Şalālah, Bawshar, Sohar', utc: '+04:00' },
    { id: 'Asia/Tbilisi', name: 'Tbilisi, Kutaisi, Batumi, Sokhumi, Zugdidi', utc: '+04:00' },
    { id: 'Asia/Yerevan', name: 'Yerevan, Gyumri, Vanadzor, Vagharshapat, Hrazdan', utc: '+04:00' },
    {
        id: 'Europe/Astrakhan',
        name: 'Astrakhan, Akhtubinsk, Znamensk, Kharabali, Kamyzyak',
        utc: '+04:00',
    },
    {
        id: 'Europe/Samara',
        name: "Samara, Togliatti-on-the-Volga, Izhevsk, Syzran', Novokuybyshevsk",
        utc: '+04:00',
    },
    { id: 'Europe/Saratov', name: "Saratov, Balakovo, Engel's, Balashov, Vol'sk", utc: '+04:00' },
    {
        id: 'Europe/Ulyanovsk',
        name: "Ulyanovsk, Dimitrovgrad, Inza, Barysh, Novoul'yanovsk",
        utc: '+04:00',
    },
    {
        id: 'Indian/Mahe',
        name: 'Victoria, Anse Boileau, Bel Ombre, Beau Vallon, Cascade',
        utc: '+04:00',
    },
    {
        id: 'Indian/Mauritius',
        name: 'Port Louis, Beau Bassin-Rose Hill, Vacoas, Curepipe, Quatre Bornes',
        utc: '+04:00',
    },
    {
        id: 'Indian/Reunion',
        name: 'Saint-Denis, Saint-Paul, Saint-Pierre, Le Tampon, Saint-André',
        utc: '+04:00',
    },
    { id: 'Asia/Kabul', name: 'Kabul, Kandahār, Mazār-e Sharīf, Herāt, Jalālābād', utc: '+04:30' },
    { id: 'Antarctica/Mawson', name: 'Mawson', utc: '+05:00' },
    { id: 'Asia/Aqtau', name: 'Shevchenko, Zhanaozen, Beyneu, Shetpe, Yeraliyev', utc: '+05:00' },
    { id: 'Asia/Aqtobe', name: 'Aktobe, Kandyagash, Shalqar, Khromtau, Embi', utc: '+05:00' },
    { id: 'Asia/Ashgabat', name: 'Ashgabat, Türkmenabat, Daşoguz, Mary, Balkanabat', utc: '+05:00' },
    { id: 'Asia/Atyrau', name: 'Atyrau, Qulsary, Shalkar, Balykshi, Maqat', utc: '+05:00' },
    { id: 'Asia/Dushanbe', name: 'Dushanbe, Khujand, Kŭlob, Bokhtar, Istaravshan', utc: '+05:00' },
    { id: 'Asia/Karachi', name: 'Karachi, Lahore, Faisalabad, Rawalpindi, Multan', utc: '+05:00' },
    { id: 'Asia/Oral', name: 'Oral, Aqsay, Zhänibek, Tasqala, Zhumysker', utc: '+05:00' },
    { id: 'Asia/Qyzylorda', name: 'Kyzylorda, Baikonur, Novokazalinsk, Aral, Chiili', utc: '+05:00' },
    { id: 'Asia/Samarkand', name: 'Samarkand, Bukhara, Nukus, Qarshi, Jizzax', utc: '+05:00' },
    { id: 'Asia/Tashkent', name: "Tashkent, Namangan, Andijon, Qo'qon, Chirchiq", utc: '+05:00' },
    {
        id: 'Asia/Yekaterinburg',
        name: 'Yekaterinburg, Chelyabinsk, Ufa, Perm, Orenburg',
        utc: '+05:00',
    },
    { id: 'Indian/Kerguelen', name: 'Port-aux-Français', utc: '+05:00' },
    {
        id: 'Indian/Maldives',
        name: 'Male, Fuvahmulah, Hithadhoo, Kulhudhuffushi, Thinadhoo',
        utc: '+05:00',
    },
    {
        id: 'Asia/Colombo',
        name: 'Colombo, Dehiwala-Mount Lavinia, Moratuwa, Jaffna, Negombo',
        utc: '+05:30',
    },
    { id: 'Asia/Kolkata', name: 'Mumbai, Delhi, Bengaluru, Kolkata, Chennai', utc: '+05:30' },
    { id: 'Asia/Kathmandu', name: 'Kathmandu, Pokhara, Pātan, Biratnagar, Birgañj', utc: '+05:45' },
    { id: 'Antarctica/Vostok', name: 'Vostok', utc: '+06:00' },
    { id: 'Asia/Almaty', name: 'Almaty, Karagandy, Shymkent, Taraz, Nur-Sultan', utc: '+06:00' },
    { id: 'Asia/Bishkek', name: 'Bishkek, Osh, Jalal-Abad, Karakol, Tokmok', utc: '+06:00' },
    { id: 'Asia/Dhaka', name: 'Dhaka, Chattogram, Khulna, Rājshāhi, Comilla', utc: '+06:00' },
    { id: 'Asia/Omsk', name: 'Omsk, Tara, Kalachinsk, Znamenskoye, Tavricheskoye', utc: '+06:00' },
    { id: 'Asia/Qostanay', name: 'Kostanay, Rudnyy, Dzhetygara, Arkalyk, Lisakovsk', utc: '+06:00' },
    {
        id: 'Asia/Thimphu',
        name: 'himphu, Punākha, Tsirang, Phuntsholing, Pemagatshel',
        utc: '+06:00',
    },
    { id: 'Asia/Urumqi', name: 'Zhongshan, Ürümqi, Zhanjiang, Shihezi, Huocheng', utc: '+06:00' },
    { id: 'Indian/Chagos', name: 'British Indian Ocean Territory', utc: '+06:00' },
    {
        id: 'Asia/Yangon',
        name: 'Yangon, Mandalay, Nay Pyi Taw, Mawlamyine, Kyain Seikgyi Township',
        utc: '+06:30',
    },
    { id: 'Indian/Cocos', name: 'West Island', utc: '+06:30' },
    { id: 'Antarctica/Davis', name: 'Davis', utc: '+07:00' },
    {
        id: 'Asia/Bangkok',
        name: 'Bangkok, Hanoi, Haiphong, Samut Prakan, Mueang Nonthaburi',
        utc: '+07:00',
    },
    {
        id: 'Asia/Barnaul',
        name: 'Barnaul, Biysk, Rubtsovsk, Novoaltaysk, Gorno-Altaysk',
        utc: '+07:00',
    },
    { id: 'Asia/Hovd', name: 'Khovd, Ölgii, Ulaangom, Uliastay, Altai', utc: '+07:00' },
    {
        id: 'Asia/Ho_Chi_Minh',
        name: 'Ho Chi Minh City, Da Nang, Biên Hòa, Nha Trang, Cần Thơ',
        utc: '+07:00',
    },
    { id: 'Asia/Jakarta', name: 'Jakarta, Surabaya, Medan, Bandung, Bekasi', utc: '+07:00' },
    { id: 'Asia/Krasnoyarsk', name: 'Krasnoyarsk, Abakan, Norilsk, Achinsk, Kyzyl', utc: '+07:00' },
    {
        id: 'Asia/Novokuznetsk',
        name: "Novokuznetsk, Kemerovo, Prokop'yevsk, Leninsk-Kuznetsky, Kiselëvsk",
        utc: '+07:00',
    },
    {
        id: 'Asia/Novosibirsk',
        name: 'Novosibirsk, Berdsk, Iskitim, Akademgorodok, Kuybyshev',
        utc: '+07:00',
    },
    {
        id: 'Asia/Phnom_Penh',
        name: 'Phnom Penh, Takeo, Sihanoukville, Battambang, Siem Reap',
        utc: '+07:00',
    },
    {
        id: 'Asia/Pontianak',
        name: 'Pontianak, Tanjung Pinang, Palangkaraya, Singkawang, Sampit',
        utc: '+07:00',
    },
    { id: 'Asia/Tomsk', name: 'Tomsk, Seversk, Strezhevoy, Kolpashevo, Asino', utc: '+07:00' },
    {
        id: 'Asia/Vientiane',
        name: 'Vientiane, Pakse, Thakhèk, Savannakhet, Luang Prabang',
        utc: '+07:00',
    },
    { id: 'Indian/Christmas', name: 'Flying Fish Cove', utc: '+07:00' },
    {
        id: 'Asia/Brunei',
        name: 'Bandar Seri Begawan, Kuala Belait, Seria, Tutong, Bangar',
        utc: '+08:00',
    },
    { id: 'Asia/Choibalsan', name: 'Baruun-Urt, Choibalsan', utc: '+08:00' },
    {
        id: 'Asia/Hong_Kong',
        name: 'Hong Kong, Kowloon, Tsuen Wan, Yuen Long Kau Hui, Tung Chung',
        utc: '+08:00',
    },
    { id: 'Asia/Irkutsk', name: "Irkutsk, Ulan-Ude, Bratsk, Angarsk, Ust'-Ilimsk", utc: '+08:00' },
    {
        id: 'Asia/Kuala_Lumpur',
        name: 'Kota Bharu, Kuala Lumpur, Klang, Kampung Baru Subang, Johor Bahru',
        utc: '+08:00',
    },
    { id: 'Asia/Kuching', name: 'Kuching, Kota Kinabalu, Sandakan, Tawau, Miri', utc: '+08:00' },
    { id: 'Asia/Macau', name: 'Macau', utc: '+08:00' },
    {
        id: 'Asia/Makassar',
        name: 'Makassar, Denpasar, City of Balikpapan, Banjarmasin, Manado',
        utc: '+08:00',
    },
    { id: 'Asia/Manila', name: 'Quezon City, Manila, Caloocan City, Budta, Davao', utc: '+08:00' },
    { id: 'Asia/Shanghai', name: 'Shanghai, Beijing, Tianjin, Guangzhou, Shenzhen', utc: '+08:00' },
    { id: 'Asia/Singapore', name: 'Singapore, Woodlands', utc: '+08:00' },
    { id: 'Asia/Taipei', name: 'Taipei, Kaohsiung, Taichung, Tainan, Banqiao', utc: '+08:00' },
    { id: 'Asia/Ulaanbaatar', name: 'Ulan Bator, Erdenet, Darhan, Hovd, Mörön', utc: '+08:00' },
    { id: 'Australia/Perth', name: 'Perth, Rockingham, Mandurah, Bunbury, Albany', utc: '+08:00' },
    { id: 'Australia/Eucla', name: 'Eucla', utc: '+08:45' },
    {
        id: 'Asia/Chita',
        name: "Chita, Krasnokamensk, Borzya, Petrovsk-Zabaykal'skiy, Aginskoye",
        utc: '+09:00',
    },
    { id: 'Asia/Dili', name: 'Dili, Maliana, Suai, Likisá, Aileu', utc: '+09:00' },
    { id: 'Asia/Jayapura', name: 'Ambon, Jayapura, Sorong, Ternate, Abepura', utc: '+09:00' },
    { id: 'Asia/Khandyga', name: 'Khandyga', utc: '+09:00' },
    { id: 'Asia/Pyongyang', name: "Pyongyang, Hamhŭng, Namp'o, Sunch'ŏn, Hŭngnam", utc: '+09:00' },
    { id: 'Asia/Seoul', name: 'Seoul, Busan, Incheon, Daegu, Daejeon', utc: '+09:00' },
    { id: 'Asia/Tokyo', name: 'Tokyo, Yokohama, Osaka, Nagoya, Sapporo', utc: '+09:00' },
    {
        id: 'Asia/Yakutsk',
        name: 'Yakutsk, Blagoveshchensk, Belogorsk, Neryungri, Svobodnyy',
        utc: '+09:00',
    },
    {
        id: 'Pacific/Palau',
        name: 'Koror, Koror Town, Kloulklubed, Ulimang, Mengellang',
        utc: '+09:00',
    },
    {
        id: 'Australia/Adelaide',
        name: 'Adelaide, Adelaide Hills, Mount Gambier, Morphett Vale, Gawler',
        utc: '+09:30',
    },
    { id: 'Australia/Broken_Hill', name: 'Broken Hill', utc: '+09:30' },
    {
        id: 'Australia/Darwin',
        name: 'Darwin, Alice Springs, Palmerston, Howard Springs',
        utc: '+09:30',
    },
    { id: 'Antarctica/DumontDUrville', name: 'DumontDUrville', utc: '+10:00' },
    { id: 'Antarctica/Macquarie', name: 'Macquarie', utc: '+10:00' },
    { id: 'Asia/Ust-Nera', name: 'Ust-Nera', utc: '+10:00' },
    {
        id: 'Asia/Vladivostok',
        name: 'Vladivostok, Khabarovsk, Khabarovsk Vtoroy, Komsomolsk-on-Amur, Ussuriysk',
        utc: '+10:00',
    },
    {
        id: 'Australia/Brisbane',
        name: 'Brisbane, Gold Coast, Logan City, Townsville, Cairns',
        utc: '+10:00',
    },
    { id: 'Australia/Currie', name: 'Currie', utc: '+10:00' },
    {
        id: 'Australia/Hobart',
        name: 'Hobart, Launceston, Burnie, Devonport, Sandy Bay',
        utc: '+10:00',
    },
    { id: 'Australia/Lindeman', name: 'Lindeman', utc: '+10:00' },
    {
        id: 'Australia/Melbourne',
        name: 'Melbourne, Geelong, Bendigo, Ballarat, Melbourne City Centre',
        utc: '+10:00',
    },
    {
        id: 'Australia/Sydney',
        name: 'Sydney, Canberra, Newcastle, Wollongong, Maitland',
        utc: '+10:00',
    },
    { id: 'Pacific/Chuuk', name: 'Weno, Colonia', utc: '+10:00' },
    {
        id: 'Pacific/GuamVillage',
        name: 'Dededo Village, Yigo Village, Tamuning, Tamuning-Tumon-Harmon Village, Mangilao Village',
        utc: '+10:00',
    },
    {
        id: 'Pacific/Port_Moresby',
        name: 'Port Moresby, Lae, Mount Hagen, Popondetta, Madang',
        utc: '+10:00',
    },
    { id: 'Pacific/Saipan', name: 'Saipan, San Jose Village', utc: '+10:00' },
    { id: 'Australia/Lord_Howe', name: 'Lord Howe', utc: '+10:30' },
    { id: 'Antarctica/Casey', name: 'Casey', utc: '+11:00' },
    { id: 'Asia/Magadan', name: 'Magadan, Ust-Nera, Susuman, Ola', utc: '+11:00' },
    {
        id: 'Asia/Sakhalin',
        name: "Yuzhno-Sakhalinsk, Korsakov, Kholmsk, Okha, Nevel'sk",
        utc: '+11:00',
    },
    { id: 'Asia/Srednekolymsk', name: 'Srednekolymsk', utc: '+11:00' },
    { id: 'Pacific/Bougainville', name: 'Arawa, Buka', utc: '+11:00' },
    { id: 'Pacific/Efate', name: 'Port-Vila, Luganville, Isangel, Sola, Lakatoro', utc: '+11:00' },
    { id: 'Pacific/Guadalcanal', name: 'Honiara, Malango, Auki, Gizo, Buala', utc: '+11:00' },
    { id: 'Pacific/Kosrae', name: 'Tofol', utc: '+11:00' },
    { id: 'Pacific/Norfolk', name: 'Kingston', utc: '+11:00' },
    { id: 'Pacific/Noumea', name: 'Nouméa, Mont-Dore, Dumbéa, Païta, Wé', utc: '+11:00' },
    {
        id: 'Pacific/Pohnpei',
        name: 'Kolonia, Kolonia Town, Palikir - National Government Center',
        utc: '+11:00',
    },
    { id: 'Antarctica/McMurdo', name: 'McMurdo', utc: '+12:00' },
    { id: 'Asia/Anadyr', name: 'Anadyr, Bilibino', utc: '+12:00' },
    {
        id: 'Asia/Kamchatka',
        name: "Petropavlovsk-Kamchatsky, Yelizovo, Vilyuchinsk, Klyuchi, Mil'kovo",
        utc: '+12:00',
    },
    {
        id: 'Pacific/Auckland',
        name: 'Auckland, Wellington, Christchurch, Manukau City, North Shore',
        utc: '+12:00',
    },
    { id: 'Pacific/Fiji', name: 'Suva, Lautoka, Nadi, Labasa, Ba', utc: '+12:00' },
    {
        id: 'Pacific/Funafuti',
        name: 'Funafuti, Savave Village, Tanrake Village, Toga Village, Asau Village',
        utc: '+12:00',
    },
    { id: 'Pacific/Kwajalein', name: 'Ebaye, Jabat', utc: '+12:00' },
    { id: 'Pacific/Majuro', name: 'Majuro, Arno, Jabor, Wotje, Mili', utc: '+12:00' },
    { id: 'Pacific/Nauru', name: 'Yaren, Baiti, Anabar, Uaboe, Ijuw', utc: '+12:00' },
    { id: 'Pacific/Tarawa', name: 'Tarawa, Betio Village, Bikenibeu Village', utc: '+12:00' },
    { id: 'Pacific/Wake', name: 'Wake', utc: '+12:00' },
    { id: 'Pacific/Wallis', name: 'Mata-Utu, Leava, Alo', utc: '+12:00' },
    { id: 'Pacific/Chatham', name: 'Waitangi', utc: '+12:45' },
    { id: 'Pacific/Apia', name: 'Apia, Asau, Mulifanua, Afega, Leulumoega', utc: '+13:00' },
    { id: 'Pacific/Enderbury', name: 'Enderbury', utc: '+13:00' },
    { id: 'Pacific/Fakaofo', name: 'Atafu Village, Nukunonu, Fale old settlement', utc: '+13:00' },
    { id: 'Pacific/Tongatapu', name: "Nuku'alofa, Lapaha, Neiafu, Pangai, 'Ohonua", utc: '+13:00' },
    { id: 'Pacific/Kiritimati', name: 'Kiritimati', utc: '+14:00' },
];
export function getTimeZoneOptions() {
    return AllTimeZones.map((v) => ({ value: v.id, label: `(GMT${v.utc}) ${v.name}` }));
}
